import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { find, map } from "lodash";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Modal from "@mui/material/Modal";
import { Grid } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { getClassNames, checkLearner } from "../../Js/Common";
import Slide from "@mui/material/Slide";

const style = {
  position: "absolute",
  top: "35%",
  left: "40%",
  transform: "translate(-50%, -50%)",
  width: 300,
  "@media (min-width: 1636px)": {
    width: "28rem",
  },
  bgcolor: "#F5F7FF",
  border: "2px solid #FFFFFF",
  borderRadius: 10,
  p: 4,
};

const TeachingModal = (props) => {
  const containerRef = React.useRef(null);
  const [timeoutObj, setTimeoutObj] = useState(null);
  const [initialRender, setInitialRender] = useState(true);
  const [classes, setClasses] = useState([]);
  const [selectedclass, setSelectedClass] = useState(null);
  const [selectedclassname, setSelectedClassName] = useState(null);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);

  const classname = useStyles();

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  let selectedClasses = useSelector(
    (state) => state.assignment.selectedClasses
  );

  useEffect(() => {
    const innerFunction = async () => {
      let temp = await getClassNames(userInfo.site_uuid);
      if (userInfo.class_assigned && userInfo.class_assigned.length > 0) {
        setClasses(
          temp.filter((val) => userInfo.class_assigned.indexOf(val.id) > -1)
        );
      } else {
        setClasses(temp);
      }
    };
    innerFunction();
  }, [userInfo]);

  // select class from list
  const selectClass = (obj) => {
    console.log(obj);
  };

  useEffect(() => {
    if (props.timeout && props.visible) {
      setTimeoutObj(
        setTimeout(() => {
          props.toggleModal(false);
        }, props.timeout)
      );
    }
    if (!props.visible && timeoutObj) {
      clearTimeout(timeoutObj);
    }
    if (!initialRender && !props.visible && props.onClose) {
      props.onClose();
    }
    if (!initialRender && !props.visible) {
      setError(false);
      setErrorMsg(null);
      setSelectedClass(null);
    }
  }, [props.visible]);

  useEffect(() => {
    setInitialRender(false);
  }, []);

  const learnerAvailableCheck = async (classid) => {
    let learners = await checkLearner(classid);
    if (learners.response.total == 0) {
      setError(true);
      setErrorMsg("No learners available in this class.");
    } else {
      setError(false);
      setErrorMsg(null);
    }
  };

  return (
    <div>
      <Modal
        open={props.visible}
        onClose={() => {
          if (!props.persistent) {
            props.toggleModal(false);
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ border: "0px !important" }}
        ref={containerRef}
      >
        <Slide
          direction="up"
          in={props.visible}
          container={containerRef.current}
        >
          <Box
            sx={{
              ...style,
              backgroundColor: "primary.main",
              border: 0,
              borderRadius: 6,
            }}
          >
            <Grid
              container
              sx={{
                flexDirection: "row",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
              }}
            >
              <Grid item xs={12}>
                <Typography
                  id="modal-modal-title"
                  sx={{
                    color: "#FFFFFF",
                    fontSize: "1.2rem",
                    fontWeight: "800",
                    textAlign: "center",
                    "@media (min-width: 1636px)": {
                      fontSize: "2rem",
                    },
                  }}
                >
                  Select Class
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth sx={{ mb: 1 }} size="small">
                  <Select
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    sx={{
                      borderRadius: 5,
                      borderColor: "#FFFFFF",
                      backgroundColor: "#F5F5F5",
                    }}
                    onChange={(val) => {
                      let foundObj = find(classes, { id: val.target.value });
                      setSelectedClassName(foundObj.value);
                      setSelectedClass(val.target.value);
                      setError(false);
                      setErrorMsg(null);
                    }}
                  >
                    {classes &&
                      classes.map((val, index1) => {
                        return (
                          <MenuItem
                            value={val.id}
                            key={`${index1}_classes_teach`}
                            onClick={() => {
                              learnerAvailableCheck(val.id);
                            }}
                          >
                            {val.value}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
                <Grid item sx={{ textAlign: "center" }}>
                  {error && (
                    <Grid>
                      <Typography className={classname.errorMessage}>
                        {errorMsg ? errorMsg : ""}
                      </Typography>
                    </Grid>
                  )}
                  <Button
                    variant="contained"
                    fullWidth
                    sx={{
                      borderRadius: 10,
                      backgroundColor: "#FFF",
                      color: "primary.main",
                      fontWeight: "bold",
                      mt: 3,
                      px: 2,
                     
                      "@media (min-width: 1636px)": {
                        fontSize: "1.4rem",
                      },
                    }}
                    disabled={error}
                    onClick={() => {
                      if (selectedclass) {
                        props.go(selectedclass, selectedclassname);
                      } else {
                        setError(true);
                        setErrorMsg("Please select a class");
                      }
                    }}
                  >
                    Go
                  </Button>
                </Grid>
                <Grid item sx={{ textAlign: "center" }}>
                  <Button
                    variant="contained"
                    fullWidth
                    sx={{
                      borderRadius: 10,
                      border: 1,
                      borderColor: "#FFFFFF",
                      color: "#FFF",
                      fontWeight: "bold",
                      mt: 2,
                      px: 2,
                      "@media (min-width: 1636px)": {
                        fontSize: "1.4rem",
                      },
                    }}
                    onClick={() => {
                      props.toggleModal(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Slide>
      </Modal>
    </div>
  );
};
const useStyles = makeStyles({
  image: {
    width: "14rem",
    "@media (min-width: 1636px)": {
      width: "20rem",
    },
  },
  errorMessage: {
    backgroundColor: "red",
    color: "#FFFFFF",
    borderRadius: 30,
    padding: "10px 20px",
  },
});
export default TeachingModal;
